import { IconMusic, IconQuestionMark, } from "@tabler/icons-react";
import { sidebarTranslations } from "@/shared/locales";
export const translations = sidebarTranslations;
export const mainNavItems = [
    // {
    //   to: "/my-videos",
    //   icon: IconVideo,
    //   labelKey: "myVideos",
    // },
    // {
    //   to: "/my-poems",
    //   icon: IconWriting,
    // labelKey: "myPoems",
    // },
    {
        to: "/my-songs",
        icon: IconMusic,
        labelKey: "mySongs",
    },
    // {
    //   to: "/charts",
    //   icon: IconChartBar,
    //   labelKey: "charts",
    // },
    // {
    //   to: "/my-photos",
    //   icon: IconPhoto,
    //   labelKey: "myPhotos",
    // },
    // {
    //   to: "/my-greetings",
    //   icon: IconGift,
    //   labelKey: "myGreetings",
    // },
    // {
    //   to: "/my-vocal-removal",
    //   icon: IconMicrophoneOff,
    //   labelKey: "myVocalRemoval",
    // },
    // {
    //   to: "/my-portraits",
    //   icon: IconUser,
    //   labelKey: "myPortraits",
    // },
    // {
    //   to: "/my-clips",
    //   icon: IconMovie,
    //   labelKey: "myClips",
    // },
];
export const personalizationItems = [
    // { to: "/support", icon: IconHelp, labelKey: "support" },
    { to: "/faq", icon: IconQuestionMark, labelKey: "faq" },
];
